// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"P11TextIntroductionTwoColumn_imageContainer__UlCVk","image":"P11TextIntroductionTwoColumn_image__pdrYs"};